/**
 * Confirm password reset from email link (Djoser uid + token).
 */

import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';
import Seo from '../components/Seo';
import './Login.css';

const PasswordResetConfirm = () => {
  const { uid, token } = useParams();
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [rePassword, setRePassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== rePassword) {
      setError(t('login.errPasswordMatch'));
      return;
    }
    if (password.length < 8) {
      setError(t('login.errWeakPassword'));
      return;
    }
    setLoading(true);
    try {
      await axios.post('/api/auth/users/reset_password_confirm/', {
        uid,
        token,
        new_password: password,
        re_new_password: rePassword,
      });
      setDone(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      const data = err.response?.data;
      const msg =
        data?.token?.[0] ||
        data?.uid?.[0] ||
        data?.new_password?.[0] ||
        data?.non_field_errors?.[0] ||
        t('login.resetInvalid');
      setError(typeof msg === 'string' ? msg : t('login.resetInvalid'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <Seo
        title={t('login.resetConfirmTitle')}
        description={t('login.resetConfirmLead')}
        path="/password/reset/confirm"
        noindex
      />
      <div className="auth-card">
        <h1 className="auth-card__title">{t('login.resetConfirmTitle')}</h1>
        <p className="auth-card__lead">{t('login.resetConfirmLead')}</p>

        {done ? (
          <div className="auth-alert auth-alert--success" role="status">
            <span>{t('login.resetConfirmSuccess')}</span>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="new_password">{t('login.password')}</label>
              <input
                type="password"
                id="new_password"
                data-clarity-mask="true"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
                required
                minLength={8}
              />
            </div>
            <div className="form-group">
              <label htmlFor="re_new_password">{t('login.confirmPassword')}</label>
              <input
                type="password"
                id="re_new_password"
                data-clarity-mask="true"
                value={rePassword}
                onChange={(e) => setRePassword(e.target.value)}
                autoComplete="new-password"
                required
                minLength={8}
              />
            </div>
            {error && (
              <div className="auth-alert auth-alert--error" role="alert">
                <span>{error}</span>
              </div>
            )}
            <button type="submit" className="btn btn-primary auth-card__submit" disabled={loading}>
              {loading ? t('login.submitting') : t('login.resetConfirmSubmit')}
            </button>
          </form>
        )}

        <Link to="/login" className="auth-card__back">
          ← {t('login.titleLogin')}
        </Link>
      </div>
    </div>
  );
};

export default PasswordResetConfirm;
